const localeEn = {
  // Empty view
  UDE_EMPTY_TITLE: 'You have not enrolled in a track yet',
  UDE_EMPTY_DESC:
    'Are you familiar with our tracks? Unlock your full potential with the different learning paths we offer. Learn more here.',
  // Error view
  UDE_ENROLLED_TRACKS_ERROR:
    'An error occurred while retrieving your enrolled tracks',
  UDE_TRACKS_ERROR: 'An error occurred while retrieving the tracks',
  // Track card
  UDE_TRACK_COMPLETED: 'Track completed',
};
export default localeEn;
